//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Silo
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xCD7ae3373F7e76A817238261b8303FA17D2AF585)
 */
export const siloAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_repository',
        internalType: 'contract ISiloRepository',
        type: 'address',
      },
      { name: '_siloAsset', internalType: 'address', type: 'address' },
      { name: '_version', internalType: 'uint128', type: 'uint128' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AssetDoesNotExist' },
  { type: 'error', inputs: [], name: 'BorrowNotPossible' },
  { type: 'error', inputs: [], name: 'DepositNotPossible' },
  { type: 'error', inputs: [], name: 'DepositsExceedLimit' },
  { type: 'error', inputs: [], name: 'DifferentArrayLength' },
  { type: 'error', inputs: [], name: 'InvalidRepository' },
  { type: 'error', inputs: [], name: 'InvalidSiloVersion' },
  { type: 'error', inputs: [], name: 'LiquidationReentrancyCall' },
  { type: 'error', inputs: [], name: 'MaximumLTVReached' },
  { type: 'error', inputs: [], name: 'NotEnoughDeposits' },
  { type: 'error', inputs: [], name: 'NotEnoughLiquidity' },
  { type: 'error', inputs: [], name: 'NotSolvent' },
  { type: 'error', inputs: [], name: 'OnlyRouter' },
  { type: 'error', inputs: [], name: 'Paused' },
  { type: 'error', inputs: [], name: 'TokenIsNotAContract' },
  { type: 'error', inputs: [], name: 'UnexpectedEmptyReturn' },
  { type: 'error', inputs: [], name: 'UnsupportedLTVType' },
  { type: 'error', inputs: [], name: 'UserIsZero' },
  { type: 'error', inputs: [], name: 'ZeroAssets' },
  { type: 'error', inputs: [], name: 'ZeroShares' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'status',
        internalType: 'enum IBaseSilo.AssetStatus',
        type: 'uint8',
        indexed: true,
      },
    ],
    name: 'AssetStatusUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Borrow',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'depositor',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'collateralOnly',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'Deposit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'shareAmountRepaid',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'seizedCollateral',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Liquidate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Repay',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'depositor',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'receiver',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'collateralOnly',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'Withdraw',
  },
  {
    type: 'function',
    inputs: [],
    name: 'VERSION',
    outputs: [{ name: '', internalType: 'uint128', type: 'uint128' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'accrueInterest',
    outputs: [{ name: 'interest', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'assetStorage',
    outputs: [
      {
        name: '',
        internalType: 'struct IBaseSilo.AssetStorage',
        type: 'tuple',
        components: [
          {
            name: 'collateralToken',
            internalType: 'contract IShareToken',
            type: 'address',
          },
          {
            name: 'collateralOnlyToken',
            internalType: 'contract IShareToken',
            type: 'address',
          },
          {
            name: 'debtToken',
            internalType: 'contract IShareToken',
            type: 'address',
          },
          { name: 'totalDeposits', internalType: 'uint256', type: 'uint256' },
          {
            name: 'collateralOnlyDeposits',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'totalBorrowAmount',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'borrow',
    outputs: [
      { name: 'debtAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'debtShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_borrower', internalType: 'address', type: 'address' },
      { name: '_receiver', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'borrowFor',
    outputs: [
      { name: 'debtAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'debtShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_borrower', internalType: 'address', type: 'address' },
    ],
    name: 'borrowPossible',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_collateralOnly', internalType: 'bool', type: 'bool' },
    ],
    name: 'deposit',
    outputs: [
      { name: 'collateralAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'collateralShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_depositor', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_collateralOnly', internalType: 'bool', type: 'bool' },
    ],
    name: 'depositFor',
    outputs: [
      { name: 'collateralAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'collateralShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_depositor', internalType: 'address', type: 'address' },
    ],
    name: 'depositPossible',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_users', internalType: 'address[]', type: 'address[]' },
      { name: '_flashReceiverData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'flashLiquidate',
    outputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      {
        name: 'receivedCollaterals',
        internalType: 'uint256[][]',
        type: 'uint256[][]',
      },
      {
        name: 'shareAmountsToRepay',
        internalType: 'uint256[][]',
        type: 'uint256[][]',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAssets',
    outputs: [{ name: 'assets', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAssetsWithState',
    outputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      {
        name: 'assetsStorage',
        internalType: 'struct IBaseSilo.AssetStorage[]',
        type: 'tuple[]',
        components: [
          {
            name: 'collateralToken',
            internalType: 'contract IShareToken',
            type: 'address',
          },
          {
            name: 'collateralOnlyToken',
            internalType: 'contract IShareToken',
            type: 'address',
          },
          {
            name: 'debtToken',
            internalType: 'contract IShareToken',
            type: 'address',
          },
          { name: 'totalDeposits', internalType: 'uint256', type: 'uint256' },
          {
            name: 'collateralOnlyDeposits',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'totalBorrowAmount',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'harvestProtocolFees',
    outputs: [
      {
        name: 'harvestedAmounts',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'initAssetsTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'interestData',
    outputs: [
      {
        name: '',
        internalType: 'struct IBaseSilo.AssetInterestData',
        type: 'tuple',
        components: [
          {
            name: 'harvestedProtocolFees',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'protocolFees', internalType: 'uint256', type: 'uint256' },
          {
            name: 'interestRateTimestamp',
            internalType: 'uint64',
            type: 'uint64',
          },
          {
            name: 'status',
            internalType: 'enum IBaseSilo.AssetStatus',
            type: 'uint8',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_user', internalType: 'address', type: 'address' }],
    name: 'isSolvent',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'liquidity',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'repay',
    outputs: [
      { name: 'repaidAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'repaidShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_borrower', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'repayFor',
    outputs: [
      { name: 'repaidAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'repaidShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloAsset',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloRepository',
    outputs: [
      { name: '', internalType: 'contract ISiloRepository', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'syncBridgeAssets',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'utilizationData',
    outputs: [
      {
        name: 'data',
        internalType: 'struct IBaseSilo.UtilizationData',
        type: 'tuple',
        components: [
          { name: 'totalDeposits', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalBorrowAmount',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'interestRateTimestamp',
            internalType: 'uint64',
            type: 'uint64',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_collateralOnly', internalType: 'bool', type: 'bool' },
    ],
    name: 'withdraw',
    outputs: [
      { name: 'withdrawnAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'withdrawnShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_depositor', internalType: 'address', type: 'address' },
      { name: '_receiver', internalType: 'address', type: 'address' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_collateralOnly', internalType: 'bool', type: 'bool' },
    ],
    name: 'withdrawFor',
    outputs: [
      { name: 'withdrawnAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'withdrawnShare', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xCD7ae3373F7e76A817238261b8303FA17D2AF585)
 */
export const siloAddress = {
  1: '0xCD7ae3373F7e76A817238261b8303FA17D2AF585',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xCD7ae3373F7e76A817238261b8303FA17D2AF585)
 */
export const siloConfig = { address: siloAddress, abi: siloAbi } as const
